export default __webpack_public_path__ + "static/media/logo_ro.616f4e6c.png";